import { Model, modelRegistry } from './Model';
import { Product } from '.';
import Money from '../utilities/Money';
import { I18n } from '../wrappers/I18n';
/** A line of a GoodsIssue. Values come from the API (the admin does no money arithmetic on goods issues). */
export class GoodsIssueItem extends Model {
    static entity = 'goods_issue_items';
    id = null;
    goods_issue_id = null;
    date = null;
    product_id = null;
    unit_of_measure = null;
    tax_rate = '0.00';
    quantity = '0.000';
    purchase_price = '0.0000';
    selling_price = '0.0000';
    selling_price_after_tax = '0.0000';
    selling_value_after_tax = 0;
    tax_value = 0;
    margin_value = 0;
    purchase_value = 0;
    recorded_at = null;
    product;
    static fields() {
        return {
            id: this.attr(null),
            goods_issue_id: this.attr(null),
            date: this.attr(null),
            product_id: this.attr(null),
            unit_of_measure: this.attr(null),
            tax_rate: this.attr('0.00', value => this.round(value, 2).toFixed(2)),
            quantity: this.attr('0.000', value => this.round(value, 3).toFixed(3)),
            purchase_price: this.attr('0.0000', value => this.round(value, 4).toFixed(4)),
            selling_price: this.attr('0.0000', value => this.round(value, 4).toFixed(4)),
            selling_price_after_tax: this.attr('0.0000', value => this.round(value, 4).toFixed(4)),
            selling_value_after_tax: this.attr(0, value => Number(value) || 0),
            tax_value: this.attr(0, value => Number(value) || 0),
            margin_value: this.attr(0, value => Number(value) || 0),
            purchase_value: this.attr(0, value => Number(value) || 0),
            recorded_at: this.attr(null),
            product: this.attr(undefined, value => value ? new Product(value) : undefined),
        };
    }
    constructor(record) {
        super();
        this.$fill(record);
    }
    getQuantity() {
        return parseFloat(this.quantity);
    }
    getTaxRate() {
        return parseFloat(this.tax_rate);
    }
    getPurchasePrice() {
        return Money.parse(this.purchase_price);
    }
    getSellingPrice() {
        return Money.parse(this.selling_price);
    }
    getSellingPriceAfterTax() {
        return Money.parse(this.selling_price_after_tax);
    }
    getUnitOfMeasure() {
        return I18n.t(`products.unit_of_measure.${this.unit_of_measure}`) !== `products.unit_of_measure.${this.unit_of_measure}`
            ? I18n.t(`products.unit_of_measure.${this.unit_of_measure}`)
            : this.unit_of_measure;
    }
}
export default GoodsIssueItem;
modelRegistry.register('GoodsIssueItem', GoodsIssueItem);
//# sourceMappingURL=GoodsIssueItem.js.map